var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInfTherapy(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6203_9118)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.39235 6.68877C4.58651 6.68877 4.74391 6.53136 4.74391 6.3372V4.04492H0.0234375V6.3372C0.0234375 6.53136 0.180844 6.68877 0.375 6.68877H4.39235Z",
    fill: "#032279"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.74391 3.34088V2.12883C4.74391 1.53089 4.25745 1.04442 3.65951 1.04442H2.73523V0.351562C2.73523 0.157406 2.57782 0 2.38366 0C2.18951 0 2.0321 0.157406 2.0321 0.351562V1.04442H1.10784C0.509906 1.04442 0.0234375 1.53089 0.0234375 2.12883V3.34088H4.74391Z",
    fill: "#032279"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9813 2.71734C11.9813 1.77148 11.2237 1.00195 10.2925 1.00195C9.9458 1.00195 9.61601 1.10693 9.33717 1.30228C9.05836 1.10695 8.72852 1.00195 8.38186 1.00195C7.45064 1.00195 6.69305 1.77148 6.69305 2.71734C6.69305 3.16629 6.86576 3.58969 7.17935 3.90949C7.19569 3.92613 8.59922 5.35748 8.98964 5.75573L8.988 8.17256C8.9868 9.89534 7.58428 11.2969 5.86148 11.2969C4.14616 11.2969 2.74927 9.90832 2.73532 8.19623H3.36061C3.55477 8.19623 3.71217 8.03883 3.71217 7.84467V7.40063H1.05469V7.84467C1.05469 8.03883 1.21209 8.19623 1.40625 8.19623H2.03222C2.04616 10.296 3.75846 12 5.86151 12C7.97173 12 9.68967 10.2833 9.6911 8.17305L9.69274 5.75595C10.083 5.35791 11.4869 3.92616 11.5032 3.90949C11.816 3.59053 11.9813 3.17829 11.9813 2.71734Z",
    fill: "#032279"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6203_9118"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfTherapy);
export default __webpack_public_path__ + "static/media/infTherapy.f76750546f0ce146abd340aec26df818.svg";
export { ForwardRef as ReactComponent };